{
  "de": {
    "dashboard": {
      "greetings": {
        "afternoon": "Guten Tag {first_name}",
        "evening": "Guten Abend {first_name}",
        "morning": "Guten Morgen {first_name}",
        "night": "Gute Nacht {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Sie haben derzeit keine offenen Elemente.",
        "caught_up_title": "Sie sind auf dem neuesten Stand",
        "completed_count": "{count} abgeschlossen",
        "due_before": "Bis {date}",
        "journey_no_active_subtitle": "Für diese Einheit hat der Weg noch nicht begonnen.",
        "journey_no_active_title": "Kein aktiver Meilenstein",
        "journey_select_unit_subtitle": "Wählen Sie oben eine Einheit aus, um deren Weg anzuzeigen.",
        "journey_select_unit_title": "Einheit auswählen",
        "journey_title": "Ihr Weg",
        "open_action": "Öffnen",
        "previous_label": "Vorherige Meilensteine",
        "progress_completed": "{completed} / {total} abgeschlossen",
        "show_less": "Weniger anzeigen",
        "show_more_tasks": "{count} weitere Aufgabe anzeigen | {count} weitere Aufgaben anzeigen",
        "status_active": "In Bearbeitung",
        "status_completed": "Abgeschlossen",
        "status_planned": "Geplant",
        "todo_now_title": "Was jetzt zu tun ist",
        "upcoming_more": "{count} weitere anstehende Meilensteine"
      },
      "titles": {
        "activityFeed": "Aktivitäten",
        "assignedTasks": "Meine Aufgaben",
        "newsFeed": "Neuigkeiten",
        "ongoingTickets": "Laufend",
        "openTickets": "Offen",
        "progress": "Fortschritt",
        "tickets": "Konversationen",
        "totalTickets": "Alle Konversationen",
        "unreadTickets": "Ungelesen",
        "yourAssignedTickets": "Ihnen zugewiesen"
      }
    }
  }
}
